import { FC } from 'react';

import { useOfflineStatusHandlerPresenter } from './OfflineStatusHandler.presenter';

export const OfflineStatusHandler: FC = () => {
  useOfflineStatusHandlerPresenter();

  return null;
};
